<div [class]="styleClass" [formGroup]="addressForm">
  <p-select
    id="country"
    class="bordered-dropdown"
    [options]="countryList"
    optionLabel="name"
    formControlName="country"
    placeholder="Country"
  ></p-select>
  <input
    id="address"
    (setAddress)="setFormattedLocationAddress($event)"
    (blur)="onBlur()"
    appNoLeadingSpace
    appSearchAddress
    [chosenCountry]="chosenCountry"
    autocomplete="address-line1"
    class="input-primary sm"
    formControlName="address"
    pInputText
    placeholder="Address Line 1"
    size="30"
    tabindex="5"
    type="text"
  />
  <input
    id="address2"
    class="input-primary sm"
    formControlName="address2"
    pInputText
    (blur)="onBlur()"
    placeholder="Address Line 2 (Optional)"
    size="30"
    tabindex="5"
    type="text"
  />
  <input
    id="city"
    (setAddress)="this.setFormattedLocationCity($event)"
    (blur)="onBlur()"
    appNoLeadingSpace
    appSearchLocation
    [chosenCountry]="chosenCountry"
    autocomplete="address-line1"
    class="input-primary sm"
    formControlName="city"
    pInputText
    placeholder="City"
    size="30"
    tabindex="5"
    type="text"
  />
  <div class="two-fields-row">
    <p-autoComplete
      id="state"
      #stateNames
      (onBlur)="checkValidState()"
      (completeMethod)="filterStates($event, true)"
      (onClear)="filteredStatesList = stateList"
      [dropdown]="true"
      [minLength]="2"
      [required]="true"
      size="small"
      [suggestions]="filteredStatesList"
      [tabindex]="7"
      autoHighlight="true"
      optionLabel="stateName"
      formControlName="state"
      styleClass="new-autocomplete-blue sm"
      placeholder="State/Province"
    ></p-autoComplete>
    <input
      id="zip"
      [tabindex]="8"
      appNoLeadingSpace
      autocomplete="postal-code"
      class="input-primary sm"
      formControlName="zipCode"
      inputmode="text"
      maxlength="7"
      pInputText
      size="30"
      type="text"
      placeholder="Zip Code"
      (blur)="onBlur()"
    />
  </div>
</div>
